import React from "react";
import "./About.css";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import aboutBody1 from "../../images/about_body1.jpg";
import aboutBody2 from "../../images/about_body2.jpg";

const About = () => (
  <div className="about-page">
    <PageBanner title="About Us" />
    {/* About Us Main Content */}
    <ScrollReveal variant="fadeUp">
    <section className="about-main-section unique-grid-bg">
      <div className="about-content-wrapper">
        <div className="about-text-section">
          <h2 className="about-main-title">Empowering Financial Inclusion & Growth</h2>
          <h3 className="about-company-title">About Pawansut Holdings Limited</h3>
          <div className="about-description">
            {/* <p>
              Pawansut Holdings Limited is a promising Fintech company and registered NBFC. With a team of experienced professionals in the financial industry, we offer a wide range of financial services to our clients, including loans, investments, insurance, and more. Our goal is to provide affordable and accessible financial services to individuals and businesses, especially those who are underserved by traditional financial institutions. We believe that financial inclusion is key to economic growth and stability, and we are committed to helping our clients achieve their financial goals.
            </p> */}
            <p>
            Pawansut Holdings Limited is a Delhi-based Non-Banking Financial Company (NBFC) operating across India. Established in 1984 by a group of professionals and businesspersons associated with the finance sector, the Company was founded to bridge gaps in access to formal financial services for underserved individuals and businesses.

With over four decades of experience, Pawansut Holdings Limited specializes in lending and investment activities catering to a broad segment of the population. Having witnessed and adapted to multiple economic cycles, including the pre- and post-liberalization era, the Company has demonstrated resilience and sustained growth.

Aligned with industry advancements, the Company continues to evolve by leveraging technology to enhance accessibility, operational efficiency, and transparency in its financial services.

            </p>
          </div>
          <div className="about-features">
            <h3>Our Key Features:</h3>
            <ul className="feature-list">
              <li><span className="feature-icon">🔒</span> Secured Data System</li>
              <li><span className="feature-icon">💰</span> Customized Personal Loans</li>
              <li><span className="feature-icon">⚡</span> Instant Approval & Disbursal</li>
            </ul>
          </div>
        </div>
        <div className="about-images-section">
          <div className="about-image-card card-tilt">
            <img src={aboutBody1} alt="Pawansut Holdings Limited Team" />
            <div className="image-overlay">
              <span>Pawansut Holdings Limited Team</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    </ScrollReveal>
    
    {/* Disclaimer Section */}
    <ScrollReveal variant="fadeUp" delay={0.1}>
    <section className="disclaimer-section">
      <div className="disclaimer-content">
        <div className="disclaimer-image">
          <img src={aboutBody2} alt="Disclaimer Visual" />
        </div>
        <div className="disclaimer-text">
          <h2>Disclaimer</h2>
          <p>
            No information contained herein has been independently verified by anyone else. The contents of this presentation are confidential and may not be copied, distributed, redistributed or disseminated, directly or indirectly, in any manner, without the prior written consent of the Company. Unauthorised use or dissemination of the information is strictly prohibited.
          </p>
          <p>
            The NBFC does not make any guarantees, express or implied, regarding completeness, accuracy, or reliability of the information provided hereunder. The Presenter and Company disclaim any liability for errors, omissions or inaccuracies or any decisions made by participants based on the content presented.
          </p>
        </div>
      </div>
    </section>
    </ScrollReveal>
    {/* Mission & Vision Cards */}
    <ScrollReveal variant="fadeUp">
    <section className="about-cards-section">
      <div className="about-cards-grid">
        <div className="about-card">
          <div className="about-card-icon mission-icon">
            <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="20" stroke="#1565c0" strokeWidth="2.5"/><path d="M24 14v10l7 7" stroke="#1565c0" strokeWidth="2.5" strokeLinecap="round"/></svg>
          </div>
          <h3>Our Mission</h3>
          <p>To provide <strong>affordable</strong> and <strong>accessible</strong> financial services to all, empowering individuals and businesses to achieve their dreams and contribute to economic growth.</p>
        </div>
        <div className="about-card">
          <div className="about-card-icon vision-icon">
            <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="12" width="32" height="24" rx="4" stroke="#00BFAE" strokeWidth="2.5"/><path d="M16 20h16M16 24h8" stroke="#00BFAE" strokeWidth="2.5" strokeLinecap="round"/></svg>
          </div>
          <h3>Our Vision</h3>
          <p>To be a <strong>trusted leader</strong> in the fintech industry, driving <strong>financial inclusion</strong> and innovation for a brighter, more secure future for our clients and communities.</p>
        </div>
      </div>
    </section>
    </ScrollReveal>
  </div>
);

export default About; 